export const getDetailsRoute = (
  installationId: string | number = ':installationId',
  storageId: string | number = ':storageId',
  url?: string
): string => {
  if (url) {
    return `${url}/properties/emergency-power`
  }

  return `/installation/${installationId}/${storageId}/properties/emergency-power`
}

/*
 * This function is used to get the emergency power detail route of a child storage when the current selected storage is a farm server
 * @param installationId: The installation id
 * @param storageId: The storage id
 * @param childStorageId: The child storage id
 *
 */
export const getFarmDetailsRoute = (
  installationId: string | number = ':installationId',
  storageId: string | number = ':storageId',
  childStorageId: string | number = ':childStorageId',
  url?: string
): string => {
  if (url) {
    return `${url}/properties/emergency-power`
  }

  return `/installation/${installationId}/${storageId}/properties/emergency-power/${childStorageId}`
}
